import React from "react";
import { Row, Col, DatePicker, Button, Space, Tooltip, Form } from 'antd';
import { ReloadOutlined } from "@ant-design/icons";
import { Dayjs } from 'dayjs';
import { DateHelper } from '../../helper/date.helper';

const { RangePicker } = DatePicker;

export type SearchDataFilters = {
  dateRanges: [Dayjs, Dayjs];
};

const FloatingFilters = ({ onSubmit, onRefresh }: { onSubmit: (data: SearchDataFilters) => void, onRefresh: () => void }) => {
  const [form] = Form.useForm<SearchDataFilters>();

  const handleClear = () => {
    form.setFieldValue("dateRanges", DateHelper.getDayJsLastMonthRange());
  };

  const handleRefresh = () => {
    onRefresh();
  };

  const onFinish = (values: SearchDataFilters) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      name="advanced_search"
      initialValues={{ dateRanges: DateHelper.getDayJsLastMonthRange()}}
      onFinish={onFinish}
    >
      <div
        style={{
          position: "fixed",
          top: 20,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1000,
          background: "#fff",
          padding: "12px 24px",
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        }}
      >
        <Row gutter={16} justify="center" align="middle">
          <Col>
            <Form.Item<SearchDataFilters> name="dateRanges" style={{ margin: 0 }}>
              <RangePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit">
              Buscar
            </Button>
          </Col>
          <Col>
            <Button onClick={handleClear}>
              Limpiar
            </Button>
          </Col>
          <Col>
            <Tooltip title="Refrescar">
              <Button icon={<ReloadOutlined />} onClick={handleRefresh} />
            </Tooltip>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default FloatingFilters;
